import Root from "./pages/Root";

const App = () => {
  return <Root />;
};

export default App;
